import React from "react";

import { Auth } from "../../../../context/admin/Authentication";
import Edit from "./Edit";

import Screen from "../Screen";
import Overview from "./Overview";
import { StaticProvider } from "../../../../context/static/StaticContext";

export const EmailTemplates = () => {
  return (
    <StaticProvider>
      <Auth
        children={
          <Screen
            component={<Overview />}
            title="Email Templates"
          />
        }
      />
    </StaticProvider>
  );
};

export const EditEmailTemplates = () => {
  return (
    <StaticProvider>
      <Auth
        children={
          <Screen
            component={<Edit />}
            title="Edit Email Templates"
          />
        }
      />
    </StaticProvider>
  );
};
